// extracted by mini-css-extract-plugin
module.exports = {"app__header":"bp_fT","app__footer":"bp_bb","app__flex_row":"bp_fV","app__content__list":"bp_fW"};